import { render, staticRenderFns } from "./SalesBase.vue?vue&type=template&id=7a66fd83&"
import script from "./SalesBase.vue?vue&type=script&lang=js&"
export * from "./SalesBase.vue?vue&type=script&lang=js&"
import style0 from "./SalesBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports